module.exports = __webpack_public_path__ + "static/media/BladeHW_PinchTab_install.888971a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/wiper-blades-adapters/BladeHW_PinchTab_install.jpg
// module id = 815
// module chunks = 0